"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santo-stefano-d-aveto": {
    "cad1d72e": [{
      "hkey": "db8cda04",
      "slug": "santo-stefano-d-aveto",
      "name": "Santo Stefano d'Aveto",
      "primary": true,
      "skipSearch": false
    }],
    "gramizza": [{
      "hkey": "db8cda04",
      "slug": "santo-stefano-d-aveto",
      "name": "Santo Stefano d'Aveto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;